module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/creditos/components/footer-credito/footer-credito.component.scss
// module id = ./src/app/creditos/components/footer-credito/footer-credito.component.scss
// module chunks = main